import React, { useEffect, useState } from 'react';
import { useStores } from '@/store';
import { getQuery } from '../../service/http';
import { Footer } from '@/components';
import { safeVal } from '../../service/utils'
import './index.less';

const DynamicPage = () => {
  const { pageName, region, regionId, region_id } = getQuery();
  const { CommonStore } = useStores();
  const [pageHtml, setPageHtml] = useState('');
  useEffect(() => {
    CommonStore.getPageContent(safeVal(region, regionId, region_id), pageName).then(
      ({ data }) => {
        setPageHtml(data?.content || '');
      }
    );
  },[pageName]);
  return (
    <div className="hasFooterContent">
      <div
        className='dynamicPage'
        dangerouslySetInnerHTML={{ __html: pageHtml }}
      ></div>
      <Footer  hasMore={/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)}/>
    </div>
  );
};

export default DynamicPage;
